// utils
import axios from '../../utils/axios';

const createOrg = async (data, id) => {
  try {
    const response = await axios({
      method: 'post',
      url: `/organizations`,
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { createOrg };
